import moment from 'moment';
import { dateFormat } from '@utils/constants/globals';

export const getMonthDateFormat = (
  value?: string | number | Date | null,
  fallback = '-',
  timezone: 'UTC' | 'local' = 'UTC'
): any => {
  if (!value) return fallback;

  const parsedDate = timezone === 'UTC' ? moment.utc(value) : moment(value);

  if (!parsedDate.isValid()) return fallback;

  return parsedDate.format(dateFormat);
};

export const getTimeAgoFormat = (dateString: string): string => {
  if (!dateString) return '-';
  const now = moment();
  const past = moment.utc(dateString);
  const diffInSeconds = now.diff(past, 'seconds');
  if (diffInSeconds < 0) {
    return '-';
  }
  if (diffInSeconds < 60) {
    return `${diffInSeconds}s ago`;
  }

  const diffInMinutes = now.diff(past, 'minutes');
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m ago`;
  }

  const diffInHours = now.diff(past, 'hours');
  if (diffInHours < 24) {
    return `${diffInHours}h ago`;
  }

  const diffInDays = now.diff(past, 'days');
  if (diffInDays < 365) {
    return `${diffInDays}d ago`;
  }
  const diffInYears = now.diff(past, 'years');
  return `${diffInYears}y ago`;
};
